import { render, staticRenderFns } from "./SoilMapSortingControls.vue?vue&type=template&id=7e8deac4&scoped=true&lang=html&"
import script from "./SoilMapSortingControls.vue?vue&type=script&lang=js&"
export * from "./SoilMapSortingControls.vue?vue&type=script&lang=js&"
import style0 from "./SoilMapSortingControls.vue?vue&type=style&index=0&id=7e8deac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8deac4",
  null
  
)

export default component.exports